<template>
    <div>
        <app-layout>
	        <template v-slot:header>
	            <Header :title="$t('mail_logs')"
	                    :isColumns="true"
	                    @filter-div-status="datatable.filterStatus=$event"
	            >
	                <template v-slot:columns>
	                    <div class="mb-1" v-for="(column,key) in datatable.columns">
	                        <b-form-checkbox
	                            :id="'checkbox-'+key"
	                            :name="'checkbox-'+key"
	                            :value="false"
	                            :unchecked-value="true"
	                            v-model="column.hidden"
	                            v-if="column.field!='buttons'"
	                        >
	                            {{ column.label }}
	                        </b-form-checkbox>
	                    </div>
	                </template>
	            </Header>
	        </template>
	        <template v-slot:header-mobile>
		        <HeaderMobile :title="$t('mail_logs')"
		                      :isColumns="true"
		                      @filter-div-status="datatable.filterStatus=$event"
	            >
	                <template v-slot:columns>
	                    <div class="mb-1" v-for="(column,key) in datatable.columns">
	                        <b-form-checkbox
	                            :id="'checkbox-'+key"
	                            :name="'checkbox-'+key"
	                            :value="false"
	                            :unchecked-value="true"
	                            v-model="column.hidden"
	                            v-if="column.field!='buttons'"
	                        >
	                            {{ column.label }}
	                        </b-form-checkbox>
	                    </div>
	                </template>
	            </HeaderMobile>
	        </template>
            <datatable-filter v-show="datatable.filterStatus"
                              @filter="$refs.datatable.getRows()"
                              @filterClear="$refs.datatable.filterClear()"
            >
                <b-row>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('from')">
                            <b-form-input type="text" size="sm" v-model="datatable.queryParams.filter.from"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('to')">
                            <b-form-input type="text" size="sm" v-model="datatable.queryParams.filter.to"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('cc')">
                            <b-form-input type="text" size="sm" v-model="datatable.queryParams.filter.cc"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('bcc')">
                            <b-form-input type="text" size="sm" v-model="datatable.queryParams.filter.bcc"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('subject')">
                            <b-form-input type="text" size="sm" v-model="datatable.queryParams.filter.subject"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('body')">
                            <b-form-input type="text" size="sm" v-model="datatable.queryParams.filter.body"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('start_date')">
                            <select-date :is-time="true" size="sm" v-model="datatable.queryParams.filter.start_date"></select-date>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group :label="$t('end_date')">
                            <select-date :is-time="true" size="sm" v-model="datatable.queryParams.filter.end_date"></select-date>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable ref="datatable"
                       :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       v-show="datatable.showTable"
                       :data-function="callService"></datatable>
        </app-layout>
        <CommonModal id="modal" size="lg">
            <template v-slot:CommonModalTitle>
                <div>{{ $t('detail') }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <DetailForm v-if="row" :form="row"/>
            </template>
        </CommonModal>
    </div>
</template>
<script>
    import AppLayout from "@/layouts/AppLayout"
    import Header from "@/layouts/AppLayout/Header"
      import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import Datatable from "@/components/datatable/Datatable";

    import MailLogsService from "@/services/MailLogsService";
    import qs from "qs";
    import DetailForm from "@/modules/mailLogs/pages/Detail.vue";
    import LogService from "@/services/LogService";
    export default {
        components: {
            DetailForm,
            AppLayout,
            Header,
	        HeaderMobile,
            DatatableFilter,
            Datatable,
        },
        metaInfo() {
            return {
                title: this.$t('mail_logs')
            }
        },
        data() {
            return {
                formProcess:null,
                row:null,
                datatable: {

                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('detail'),
                                    class: 'ri-edit-box-line',
                                    permission: 'maillog_show',
                                    callback: (row) => {
                                        this.showDetail(row)
                                    }
                                },
                            ]
                        },
                        {
                            label: this.$t('id'),
                            field: '_id',
                            hidden: true,
                        },
                        {
                            label: this.$t('from'),
                            field: 'from',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('to'),
                            field: 'to',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('cc'),
                            field: 'cc',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('bcc'),
                            field: 'bcc',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('subject'),
                            field: 'subject',
                            hidden: false,
                            thClass: 'text-center',
                        },
                        {
                            label: this.$t('created_at'),
                            field: 'created_at',
                            hidden: false,
                            thClass: 'text-center',
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: '-created_at',
                        page: 1,
                        limit: 20
                    },

                }
            }
        },
        methods: {
            callService(config) {
                return MailLogsService.getAll(config)
            },
            getRows() {
                this.$refs.datatable.getRows();
            },
            showDetail(row){
                this.row=row
                this.$bvModal.show('modal');
            }

        }
    };
</script>

